<template>
  <div>
    <h2 class="component-title">
      {{ $t('paymentMethod') }}
    </h2>
    <p class="about-next-step">
      {{ $t('finishPaymentInNextStep') }}
    </p>
    <p
      v-if="paymentMethodsLoading"
      role="status"
    >
      {{ $t('paymentMethodsLoading') }}
    </p>
    <p
      v-else-if="!providerMethods.length"
      role="alert"
    >
      {{ $t(paymentMethodsError ? 'paymentMethodsError' : 'paymentMethodsUnavailable') }}
    </p>
    <div class="payment-methods">
      <div
        v-for="option in providerMethods"
        :key="option.id"
        class="payment-method"
        @click="selectPaymentMethod(option.id)"
      >
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">{{ buyer.paymentMethod === option.id ? 'check_circle' : 'radio_button_unchecked' }}</span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">
              {{ paymentTitle(option) }}
            </h3>
            <p class="payment-about">
              {{ paymentDescription(option) }}
            </p>
          </div>
        </div>
        <div class="payment-logo">
          <img
            v-if="paymentLogo(option)"
            :src="paymentLogo(option)"
            :alt="option.label"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentMethodsMixin from '@/payment-methods-mixin'
export default {
  name: 'sport-organization-store-payment-methods',
  mixins: [paymentMethodsMixin],
  props: { buyer: { type: Object, default: () => ({}) } },
  computed: {
    paymentEligibility() { return { keksPay: false } },
  },
  methods: {
    selectPaymentMethod(method) { this.$set(this.buyer, 'paymentMethod', method) },
  },
}
</script>

<style scoped>
.component-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 1.8rem */
  letter-spacing: -0.045rem;
}
.about-next-step {
  color: var(--Grey-00, #333);
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.payment-methods {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.payment-method {
  display: flex;
  padding: 1rem 1.5rem 1rem 1rem;
  align-items: flex-start;
  gap: 1rem;
  justify-content: space-between;
  border-radius: 0.25rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  background: #fff;
}

.payment-method-zkm {
  max-width: inherit !important;
}
@media screen and (max-width: 455px) {
  .payment-method {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .payment-logo {
    align-self: center;
  }
}
.check-box {
  margin-right: 1.125rem;
  margin-top: 5px;
}
.payment-description {
  display: flex;
}
.payment-logo {
  margin-right: 1.5rem;
}
.payment-text {
  padding-right: 0.25rem;
  flex: 1;
}
.payment-type {
  color: #979797;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 1.5rem */
  letter-spacing: -0.0375rem;
}
.payment-about {
  color: #979797;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 1.2rem */
  letter-spacing: 0.015rem;
}
</style>
